function cov_2rmu2afbjb() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Lock.tsx";
  var hash = "f05d2ee54d80bf1758f2ccd057ad9834f91f7fe3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Lock.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f05d2ee54d80bf1758f2ccd057ad9834f91f7fe3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2rmu2afbjb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2rmu2afbjb();
var Icon = (cov_2rmu2afbjb().s[0]++, {
  name: 'lock',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 12.5V19.5H18.5V12.5H5.5ZM5 10C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.25 7C17.25 4.10051 14.8995 1.75 12 1.75C9.10051 1.75 6.75 4.10051 6.75 7V12H9.25V7C9.25 5.48122 10.4812 4.25 12 4.25C13.5188 4.25 14.75 5.48122 14.75 7V12H17.25V7Z\" fill=\"currentColor\"/>"
});
export default Icon;